import React from 'react';
// Removed unused imports
import WhatsAppConnect from '../components/whatsappConnect';

const PageNavbar = () => (
  <nav className="fixed top-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 h-24 overflow-hidden">
    <img src="/Hydrocawach_logo.png" alt="HydroCawach Logo" className="h-36 w-auto object-contain" />
    <h1 className="absolute left-1/2 transform -translate-x-1/2 text-blue-600 text-lg md:text-2xl font-bold text-center">
      {/* --- UPDATED TITLE --- */}
      Water & Wastewater Treatment
    </h1>
  </nav>
);

// --- NEW DATA ARRAY FOR YOUR 7 POINTS ---
const treatmentPoints = [
  {
    title: 'Online Mixing & Effluent Neutralization',
    description: 'Instant and uniform pH adjustment through high-intensity micro-mixing. Reduces chemical use and ensures real-time neutralization of industrial effluents.',
    keywords: 'effluent mixing, pH control, wastewater optimization',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0011.667 0l3.181-3.183m-4.991-1.686a7.5 7.5 0 01-11.25 0m11.25 0a7.5 7.5 0 00-11.25 0" />
      </svg>
    )
  },
  {
    title: 'Biorefractory Breakdown & Oxidation',
    description: 'Generates hydroxyl radicals for advanced oxidation, breaking complex pollutants into biodegradable compounds. Improves COD/BOD reduction and biodegradability.',
    keywords: 'AOP, oxidation, COD reduction',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5.16 14.75H3.372v-2.1l-.38-3.8A6.75 6.75 0 019.75 3.104zM20.628 14.75h-2.148L14.64 10.409a2.25 2.25 0 01-.659-1.591v-5.714A6.75 6.75 0 0121 8.85l-.38 3.8v2.1z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
      </svg>
    )
  },
  {
    title: 'Biomass Disintegration & Bioreaction Intensification',
    description: 'Disrupts sludge and cells for faster biodegradation and higher biogas yield. Enhances anaerobic digestion and biological treatment performance.',
    keywords: 'sludge reduction, bioreactor enhancement',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    )
  },
  {
    title: 'Ballast Water Treatment',
    description: 'Provides chemical-free disinfection by destroying microorganisms and algae. Supports IMO-compliant ballast water management.',
    keywords: 'marine water treatment, eco disinfection',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3m-3.75 0l3.75-3.75M12 3v2.25m0-2.25h.008m-3.75 0h.008m-3.75 0h.008m6.75 0h.008m-3.75 0h.008m6.75 0h.008m-3.75 0h.008" />
      </svg>
    )
  },
  {
    title: 'Effluent Treatment',
    description: 'Improves coagulation, flocculation, and oxidation for faster COD/BOD removal. Ideal for industrial wastewater — textile, pharma, food, and chemical sectors.',
    keywords: 'effluent treatment, industrial wastewater, AOP',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m18-18v18m-9-18v10.5a3.375 3.375 0 01-3.375 3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 013.375-3.375H9.75" />
      </svg>
    )
  },
  {
    title: 'Cooling Tower Water',
    description: 'Prevents biofouling, scaling, and microbial growth. Enhances chemical dispersion and cooling efficiency while reducing maintenance.',
    keywords: 'cooling water treatment, biofouling control',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.412 15.655a2.25 2.25 0 01-3.182 0l-1.141-1.141a2.25 2.25 0 010-3.182l1.141-1.141a2.25 2.25 0 013.182 0M12 8.25l.354-.354m-.354.354l-.354.354M12 8.25v3.75m0 0l.354.354m-.354-.354l-.354-.354m2.859-2.859l1.141 1.141a2.25 2.25 0 010 3.182l-1.141 1.141a2.25 2.25 0 01-3.182 0M12 15.75l-.354.354m.354-.354l.354-.354M12 15.75v-3.75m0 0l-.354-.354m.354.354l.354.354m-2.859 2.859l-1.141-1.141a2.25 2.25 0 010-3.182l1.141-1.141a2.25 2.25 0 013.182 0" />
      </svg>
    )
  },
  {
    title: 'Handpump Water Disinfection',
    description: 'Ensures chemical-free, safe drinking water using cavitation-generated radicals. Kills pathogens instantly, ideal for rural handpump systems.',
    keywords: 'rural water treatment, safe water, green disinfection',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 12.75V15m0 0l-1.125-1.125M12 15l1.125-1.125" />
      </svg>
    )
  }
];

const CoolingTowerTreatment = () => (
  <div className="bg-white text-gray-800 min-h-screen relative overflow-x-hidden">
    <PageNavbar />

    <div className="pt-32 px-4"> {/* Increased top padding for navbar */}

      {/* --- START: NEW CONTENT SECTION --- */}
      <div className="p-8 max-w-6xl mx-auto">

        {/* Introduction Paragraph */}
        <p className="text-lg text-center text-gray-700 max-w-4xl mx-auto mb-16">
          Cavitation is an eco-friendly, energy-efficient process that enhances chemical and
          biological reactions using microbubble collapse. It enables chemical-free
          oxidation, disinfection, and mixing, supporting sustainable water
          management.
        </p>

        {/* New 2-Column Grid for the 7 Points */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {treatmentPoints.map((point, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 flex flex-col hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full text-blue-600">
                  {point.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{point.title}</h3>
                  <p className="text-gray-700">{point.description}</p>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <h4 className="text-sm font-semibold text-gray-500 mb-2">KEYWORDS</h4>
                <div className="flex flex-wrap gap-2">
                  {point.keywords.split(', ').map((keyword) => (
                    <span
                      _ key={keyword}
                      className="text-xs bg-gray-200 text-gray-800 px-3 py-1 rounded-full font-medium"
                    >
                      {keyword}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* --- END: NEW CONTENT SECTION --- */}

      {/* The InteractiveMap component is no longer here */}
    </div>

    <WhatsAppConnect />

  </div>
);

export default CoolingTowerTreatment;